import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/dlr-logo-text-black.png'
import _imports_1 from '@/assets/bmwi_logo_de.svg'
import _imports_2 from '@/assets/trenz_logo.png'


const _hoisted_1 = { id: "footer-content-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "footer-logos" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Im Auftrag von:"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "DLR"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Gefördert durch:"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "Bundesministerium für Wirtschaft und Klimaschutz"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Gemanagt durch:"),
    /*#__PURE__*/_createElementVNode("img", {
      id: "trenz-logo",
      src: _imports_2,
      alt: "TRENZ GmbH"
    })
  ])
], -1)
const _hoisted_3 = { id: "footer-columns" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Contact"),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@trenz.de" }, "support@trenz.de"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("address", { style: {"font-style":"normal"} }, [
    /*#__PURE__*/_createTextVNode(" TRENZ GmbH"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Neidenburger Straße 14"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 28199 Bremen"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Germany ")
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Sitemap", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Legal", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Social Media"),
  /*#__PURE__*/_createElementVNode("a", { href: "https://twitter.com/TRENZ_GmbH" }, "TRENZ on Twitter")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("section", null, [
          _hoisted_5,
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/about" }, {
            default: _withCtx(() => [
              _createTextVNode("About")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/search" }, {
            default: _withCtx(() => [
              _createTextVNode("Search")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/categories" }, {
            default: _withCtx(() => [
              _createTextVNode("Categories")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/directory" }, {
            default: _withCtx(() => [
              _createTextVNode("Directory")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", null, [
          _hoisted_6,
          _createVNode(_component_router_link, { to: "/privacy-policy" }, {
            default: _withCtx(() => [
              _createTextVNode("Privacy Policy")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/imprint" }, {
            default: _withCtx(() => [
              _createTextVNode("Imprint")
            ]),
            _: 1
          })
        ]),
        _hoisted_7
      ])
    ])
  ]))
}